import { useEffect } from 'react'
import GlobalStyle from './globalStyles'
import HeroSection from './sections/1_Hero/HeroSection'
import MyWorkSection from './sections/2_MyWork/MyWorkSection'
import SocialsSection from './sections/3_Socials/SocialsSection'
import Navbar from './sections/Nav/Navbar'
import ReactGA from 'react-ga'

const App = () => {
  useEffect(() => {
    ReactGA.initialize('UA-204270142-2')
    ReactGA.pageview(window.location.pathname + window.location.search)
  }, [])
  return (
    <>
      <GlobalStyle />
      <Navbar />
      <HeroSection />
      <MyWorkSection />
      <SocialsSection />
      {/* <SkillsSection /> */}
    </>
  )
}

export default App
